<template>
  <div v-if="isProcess" class="c-loading-page c-loading-page--process">
    <div class="c-loading-page__overlay c-loading-page__overlay--process"></div>
    <Loading />
  </div>
</template>

<script lang="ts">
import globals from "@/general/store/modules/globals";
import { Options, Vue } from "vue-class-component";

@Options({})
export default class LoadingProcess extends Vue {
  get isProcess() {
    return globals.loadingProcess;
  }
}
</script>
